package app.smartcoding.realrate.presentation.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.compositeOver
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import app.smartcoding.realrate.domain.model.CreditRating
import app.smartcoding.realrate.localization.LocalStrings

@Composable
fun ScheduleTableHeader(columns: Int) {
    Row(
        modifier = Modifier.fillMaxSize().padding(end = 8.dp),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        repeat(columns) { index ->
            if (index > 0) {
                Spacer(Modifier.width(16.dp))
            }
            HeaderContent()
        }
    }
}

@Composable
private fun RowScope.HeaderContent() {
    val onSecondaryContainer = MaterialTheme.colorScheme.onSecondaryContainer
    val secondaryAlpha = MaterialTheme.colorScheme.secondary.copy(alpha = 0.8f)
    val primary = MaterialTheme.colorScheme.primary
    val tertiary = MaterialTheme.colorScheme.tertiary
    val surfaceContainer = MaterialTheme.colorScheme.surfaceContainer

    val excellentColor = CreditRating.EXCELLENT.color
    val badColor = CreditRating.BAD.color

    val excellentText = remember(excellentColor, surfaceContainer) {
        excellentColor.compositeOver(surfaceContainer)
    }
    val badText = remember(badColor, surfaceContainer) {
        badColor.compositeOver(surfaceContainer)
    }

    Text(
        text = LocalStrings.current.headerMonth,
        modifier = Modifier.width(22.dp),
        style = MaterialTheme.typography.labelSmall,
        maxLines = 1,
        textAlign = TextAlign.End,
        softWrap = false,
        color = onSecondaryContainer
    )
    Spacer(Modifier.width(8.dp))
    Row(
        modifier = Modifier.width(112.dp),
        horizontalArrangement = Arrangement.SpaceBetween,
    ) {
        Text(
            text = LocalStrings.current.headerDate,
            style = MaterialTheme.typography.labelSmall,
            maxLines = 1,
            softWrap = false,
            color = secondaryAlpha
        )
        Text(
            text = LocalStrings.current.headerPayment,
            style = MaterialTheme.typography.labelSmall,
            maxLines = 1,
            textAlign = TextAlign.End,
            softWrap = false,
            color = primary
        )
    }
    Spacer(Modifier.width(8.dp))
    Row(
        modifier = Modifier.weight(1.5f),
        horizontalArrangement = Arrangement.SpaceBetween,
    ) {
        Text(
            text = LocalStrings.current.headerPrincipal,
            modifier = Modifier.weight(1f).padding(start = 4.dp),
            style = MaterialTheme.typography.labelSmall,
            maxLines = 1,
            textAlign = TextAlign.Start,
            softWrap = false,
            color = excellentText
        )
        Spacer(Modifier.width(8.dp))
        Text(
            text = LocalStrings.current.headerInterest,
            modifier = Modifier.weight(1f).padding(end = 4.dp),
            style = MaterialTheme.typography.labelSmall,
            maxLines = 1,
            textAlign = TextAlign.End,
            softWrap = false,
            color = badText
        )
    }
    Spacer(Modifier.width(8.dp))
    Text(
        text = LocalStrings.current.headerBalance,
        modifier = Modifier.weight(1f),
        style = MaterialTheme.typography.labelSmall,
        maxLines = 1,
        textAlign = TextAlign.End,
        softWrap = false,
        color = tertiary
    )
}
